var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"radio-tab-group-wrap"},_vm._l((_vm.group),function(item,i){return _c('b-radio-tab',{key:i,attrs:{"text":item.text,"is-active":item.active,"is-disabled":_vm.isMniAccount ? true : item.disabled,"info-text":item.infoText,"hide-tooltip-icon":item.hideTooltipIcon},on:{"click":_vm.handleActive}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }